<template>
  <!-- <v-form ref="form" v-model="validForm"> -->
    <v-autocomplete
      v-model="periodoDistribucionSelect"
      @change="change"
      :items="periodosDistribucion"
      item-text="descripcion"
      item-value="id"
      dense
      filled
      label="Periodo distribucion"
      :return-object="returnObject"
      :rules="rules"
      :clearable="clearable"
      :disabled="disabled"
    ></v-autocomplete>
   
  <!-- </v-form> -->
</template>
<script>
import axios from "axios";

export default {
  props: {
    filtroId: { type: Array, default: null },
    periodoDistribucion: {type: Object, default: null},
    returnObject: {type: Boolean, default: true },
    clearable: { type: Boolean, default: false } ,
    disabled: { type: Boolean, default: false } ,
    rules: { type: Array },
  },
  data() {
    return {
      periodosDistribucion: [],
      periodoDistribucionSelect: null,
      // validForm: false,
      // rules: {
      //   required: (value) => !!value || "Requerido.",
      //   counter: (value) =>
      //     (value && value.length <= 1000) || "Maximo 100 caracteres",
      //   counter10: (value) =>
      //     (value && value.length <= 10) || "Maximo 10 caracteres",
      // },
    };
  },
  mounted() {

   
    if (this.periodoDistribucion) {
      this.periodoDistribucionSelect = this.periodoDistribucion;
    } 
    axios
      .get("/periodoDistribucion")
      .then((response) => {
        
        if (this.filtroId) {
          this.periodosDistribucion = response.data.filter((gen) =>
            this.filtroId.includes(gen.id)
          );
        } else {
          this.periodosDistribucion = response.data.sort((a,b) => new Date(b.fechaDesde) - new Date(a.fechaHasta));
        }


      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    change() {
      this.$emit('periodoDistribucion', this.periodoDistribucionSelect)
    }
  }
};
</script>